import { render } from "./Home.vue?vue&type=template&id=5f28d69d&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=5f28d69d&scoped=true&lang=css"

import exportComponent from "/Users/alexisbailly/Documents/Programming/Website/vueform/Wealth & Retirement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f28d69d"]])

export default __exports__